import React from "react";
import { Group } from "@mantine/core";
import DeleteAnnouncementActionIcon from "../elements/DeleteAnnouncementActionIcon";
import UpdateAnnouncementActionIcon from "../elements/UpdateAnnouncementActionIcon";
import ViewAnnouncementStatsActionIcon from "../elements/ViewAnnouncementStatsActionIcon";
import ExportAnnouncementEmployeeDataActionIcon from "../elements/ExportAnnouncementEmployeeDataActionIcon";

export type AnnouncementTableMenuProps = {
  id: number;
  status: string;
};

const editableStatuses = ["draft"];

const AnnouncementTableMenu: React.FC<AnnouncementTableMenuProps> = ({
  id,
  status,
}) => (
  <Group key={id} spacing="md">
    {editableStatuses.includes(status) ? (
      <>
        <UpdateAnnouncementActionIcon id={id} />
        <DeleteAnnouncementActionIcon id={id} />
      </>
    ) : (
      <>
        <ViewAnnouncementStatsActionIcon id={id} />
        <ExportAnnouncementEmployeeDataActionIcon id={id} />
      </>
    )}
  </Group>
);

export default AnnouncementTableMenu;
